import React, {useEffect, useState} from 'react';
import ApiService from './api/ApiService';
import {Container, Typography} from "@mui/material";
import {renderDocs} from "./utils";

const Vsos = () => {
    const [docs, setDocs] = useState([]);
    useEffect(() => {
        ApiService.getDocs('vsos')
            .then((data) => {
                setDocs(data.docs);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <Container>
            <Typography variant="h5" gutterBottom fontWeight={'bold'} align={'center'}
                        sx={{
                            mt: 2,
                            textTransform: 'uppercase',
                        }}>
                Всероссийская олимпиада школьников 2026/2027
            </Typography>
            {renderDocs(docs)}
        </Container>
    );
};

export default Vsos;